<template>
  <form @submit.prevent="login" class="flex flex-col justify-start items-end w-full">
    <!-- Mensaje de error -->
    <div v-if="errorMessage" class="w-full mb-4 bg-red-200 p-3  flex items-center">
      <!-- Icono de error -->
      <i class="ri-indeterminate-circle-fill text-red-700 text-xl mr-3"></i>
      <p class="text-red-700">{{ errorMessage }}</p>
    </div>

    <!-- Email -->
<div class="flex items-center w-full bg-white p-3 mb-3 input-container">
  <i :class="{ 'text-gray-400': !user, 'text-gray-600': user }" class="ri-user-3-line text-xl px-1"></i>
  <input type="email" v-model="user" class="flex-1 bg-white outline-none text-t16 p-2"
    placeholder="Correo Electrónico" required />
</div>

<!-- Contraseña -->
<div class="flex items-center w-full bg-white p-3 mb-3 input-container relative">
  <i :class="{ 'text-gray-400': !password, 'text-gray-600': password }" class="ri-lock-2-line text-xl px-1"></i>
  <input :type="typeControl" v-model="password" class="flex-1 bg-white outline-none text-t16 p-2"
    placeholder="Contraseña" required />
  <i @click="showPassword"
    :class="iconShowPassword + ' cursor-pointer absolute right-3 px-2 ' + (password ? 'text-gray-600' : 'text-gray-400')"></i>
</div>

<!-- Nombre del equipo -->
<div class="flex items-center w-full bg-white p-3 mb-3 input-container">
  <i :class="{ 'text-gray-400': !secret_word, 'text-gray-600': secret_word }" class="ri-home-4-line text-xl px-1"></i>
  <input type="text" v-model="secret_word" class="flex-1 bg-white outline-none text-t16 p-2"
    placeholder="Nombre del equipo" required />
</div>

    <!-- Acciones -->
    <div class="flex justify-between items-center w-full mt-4">
      <router-link :to="{ name: 'reset-password' }" class="text-costeaPrimary hover:text-costeaHover text-t14">
        Olvidé mi contraseña
      </router-link>

      <button :disabled="loading || !isFormComplete" type="submit" :class="buttonClass"
        class="text-white text-t16 rounded-md flex items-center justify-center h-12 w-40">
        <div class="flex items-center justify-center w-full">
          <svg v-if="loading" class="h-5 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
          </svg>
          <span v-else :class="isFormComplete ? 'text-white' : 'text-gray-500'">
      Iniciar sesión
    </span>
        </div>
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'FormField',
  data() {
    return {
      user: '',
      password: '',
      typeControl: 'password',
      secret_word: '',
      iconShowPassword: 'ri-eye-off-line',
      invalidUser: false,
      loading: false,
      errorMessage: '',
    };
  },

  methods: {
    ...mapMutations(['tokenAuth']),

    // Alternar visibilidad de contraseña
    showPassword() {
      if (this.typeControl === 'password') {
        this.typeControl = 'text';
        this.iconShowPassword = 'ri-eye-line';
      } else {
        this.typeControl = 'password';
        this.iconShowPassword = 'ri-eye-off-line';
      }
    },

    // Lógica de inicio de sesión
    login() {
      // Activar el estado de carga
      this.loading = true;

      axios
        .post(`https://${this.secret_word}.backend.costea.com.co/api/v1/login`, {
          email: this.user,
          password: this.password,
        })
        .then((respuesta) => {
          const token = respuesta.data.access_token;
          const instancia = respuesta.data.nombre_instancia[0].value;
          const rol = respuesta.data.rol_usuario;
          const name = respuesta.data.user_name;

          // Guardar datos en el localStorage
          localStorage.setItem('name', name);
          localStorage.setItem('rol_usuario', rol);
          localStorage.setItem('token', token);
          localStorage.setItem('email', this.user);
          localStorage.setItem('instancia', instancia);
          localStorage.setItem('secret-word', this.secret_word);

          // Configurar el token en Axios
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

          // Redirigir al dashboard
          this.$router.push('/');
        })
        .catch((error) => {
          this.handleLoginError(error);
        })
        .finally(() => {
          // Desactivar el estado de carga, independientemente del resultado
          this.loading = false;
        });
    },

    // Manejo de errores en el inicio de sesión
    handleLoginError(error) {
      if (error.response) {
        if (error.response.status === 401) {
          this.invalidUser = true;
          this.errorMessage = 'Usuario o contraseña incorrecta. Intenta de nuevo';
        } else {
          this.errorMessage = '¡Lo sentimos! Estamos presentando problemas. Regresa más tarde.';
        }
      } else if (error.request) {
        this.errorMessage = 'No estás conectado a internet, revisa tu conexión';
      } else {
        this.errorMessage = 'Error desconocido: ' + error.message;
      }
    },
  },
  computed: {
    ...mapState(['costea']),

    // Verificar si los campos están completos
    isFormComplete() {
      return this.user.trim() !== '' && this.password.trim() !== '' && this.secret_word.trim() !== '';
    },

    // Clase dinámica para el botón
    buttonClass() {
    return this.isFormComplete 
      ? 'bg-costeaPrimary text-white' 
      : 'bg-gray-200 text-gray-500';
  },
  },
};
</script>

<style>
/* Aplicar fuente DM Sans a todo */
* {
  font-family: 'DM Sans', sans-serif;
}

/* Estilos generales para los inputs */
input {
  transition: border 0.3s ease;
}

/* Estilo para el contenedor del input */
div.input-container {
  border: 2px solid #e5e7eb; /* Gris claro (default) */
  border-radius: 8px;
  transition: border-color 0.3s ease;
}

/* Cuando el usuario pase el cursor por encima */
div.input-container:hover {
  border-color: #2563eb; /* Azul */
}

/* Cuando el input tenga focus */
div.input-container:focus-within {
  border-color: #2563eb; /* Azul */
}
</style>